





if (typeof $ !== 'undefined' && typeof $.fn.foundation !== 'undefined') { $(document).foundation(); }


/*!
* Intersection Observer API "In Viewport" script
*/
document.addEventListener('DOMContentLoaded', function() {
  const targets = document.querySelectorAll('[data-in-view="once"]');

  const io = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-in-view');
        observer.unobserve(entry.target); // Stop observing after first trigger
      }
    });
  });

  targets.forEach(target => {
    io.observe(target);
  });
});

  





/*
* Light YouTube Embeds by @labnol
* Credit: https://www.labnol.org/
* https://www.labnol.org/internet/light-youtube-embeds/27941/
*/

function labnolIframe(div) {
  var iframe = document.createElement('iframe');
  iframe.setAttribute('src', 'https://www.youtube.com/embed/' + div.dataset.id + '?autoplay=1');
  iframe.setAttribute('frameborder', '0');
  iframe.setAttribute('allowfullscreen', '1');
  iframe.setAttribute('allow', 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture');
  div.parentNode.replaceChild(iframe, div);
}

function initYouTubeVideos() {
  var playerElements = document.querySelectorAll('.youtube-player');
  for (var n = 0; n < playerElements.length; n++) {
    var videoId = playerElements[n].dataset.videoid;
    var videoThumb = playerElements[n].dataset.thumbnail;
    var div = document.createElement('div');
    div.setAttribute('data-id', videoId);
    var thumbNode = document.createElement('img');
    thumbNode.setAttribute('class', 'youtube-player__thumbnail');
    thumbNode.src = '' + videoThumb + ''.replace('ID', videoId);
    div.appendChild(thumbNode);
    var playButton = document.createElement('div');
    playButton.setAttribute('class', 'play');
    div.appendChild(playButton);
    playButton.outerHTML += '<div class="overlay"></div><div class="overlay-hover"></div><svg class="youtube-player__play-button" viewBox="0 0 74 74"><circle style="opacity:0.64;stroke:#fff" cx="37" cy="37" r="36.5"></circle><circle fill="none" stroke="#fff" cx="37" cy="37" r="36.5"></circle><polygon fill="#fff" points="21,22 21,52 48,37"></polygon></svg>';
    div.onclick = function () {
      labnolIframe(this);
    };
    playerElements[n].appendChild(div);
  }
}

document.addEventListener('DOMContentLoaded', initYouTubeVideos);






  


